import React, { useState } from "react";
import "./AdminAccountModule.css";
import { changePassword } from "./adminApi";

export default function AdminAccountModule({ user, csrfToken, onSessionUpdate }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const [notice, setNotice] = useState(null);

  async function handleSubmit(event) {
    event.preventDefault();
    setNotice(null);
    if (newPassword.length < 12) {
      setNotice({ type: "error", message: "New password must contain at least 12 characters." });
      return;
    }
    if (newPassword !== confirmPassword) {
      setNotice({ type: "error", message: "Passwords do not match." });
      return;
    }
    setSaving(true);
    try {
      const data = await changePassword(currentPassword, newPassword, confirmPassword, csrfToken);
      onSessionUpdate?.(data);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setNotice({ type: "success", message: data.message || "Password changed successfully." });
    } catch (error) {
      setNotice({ type: "error", message: error.message || "Unable to change your password." });
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="bb-account-module">
      <div className="bb-account-hero">
        <div>
          <span className="bb-account-chip">ACCOUNT SECURITY</span>
          <h2>My Account</h2>
          <p>Manage your administrator profile and secure your account with a new password.</p>
        </div>
        <div className="bb-account-avatar">{(user?.name || "A").slice(0, 1).toUpperCase()}</div>
      </div>

      <div className="bb-account-grid">
        <section className="bb-account-card">
          <div className="bb-account-card-head">
            <div>
              <h3>Administrator profile</h3>
              <p>Your account identity and current access.</p>
            </div>
          </div>
          <div className="bb-account-profile-list">
            <div><span>NAME</span><strong>{user?.name}</strong></div>
            <div><span>EMAIL</span><strong>{user?.email}</strong></div>
            <div><span>ROLES</span><strong>{user?.roles?.join(", ") || "Administrator"}</strong></div>
            <div><span>STATUS</span><strong className="active">{user?.status || "active"}</strong></div>
          </div>
        </section>

        <section className="bb-account-card">
          <div className="bb-account-card-head">
            <div>
              <h3>Change password</h3>
              <p>Your current password is required before a new one can be saved.</p>
            </div>
          </div>
          <form className="bb-account-form" onSubmit={handleSubmit}>
            <label><span>Current password</span><input type="password" autoComplete="current-password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required disabled={saving} /></label>
            <label><span>New password</span><input type="password" autoComplete="new-password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} minLength={12} required disabled={saving} /><small>Minimum 12 characters.</small></label>
            <label><span>Confirm new password</span><input type="password" autoComplete="new-password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} minLength={12} required disabled={saving} /></label>
            {notice ? <div className={`bb-account-notice ${notice.type}`} role={notice.type === "error" ? "alert" : "status"}>{notice.message}</div> : null}
            <button className="bb-account-primary" type="submit" disabled={saving}>{saving ? "Updating password…" : "Change password"}</button>
          </form>
        </section>
      </div>

      <div className="bb-account-security-note">
        <strong>Security note</strong>
        <span>Changing your password signs out other active sessions for this account. Never share your password or recovery link.</span>
      </div>
    </div>
  );
}
